module.exports = __webpack_public_path__ + "media/Wolf.54cba4e5.ogg";